import React from "react";
import PropTypes from "prop-types";

const PaymentSummary = ({ totalPrice, quantityOfTickets, ticketPrice }) => {
	const formatter = Intl.NumberFormat("en-GB", {
		style: "currency",
		currency: "GBP",
	});

	return (
		<div id="paymentTableWrapper">
			<table border="1" className="table">
				<thead>
					<tr>
						<th scope="col">Quantity</th>
						<th scope="col">Price</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{quantityOfTickets}</td>
						<td>{formatter.format(ticketPrice)}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<th>Total to Pay</th>
						<td>{formatter.format(totalPrice)}</td>
					</tr>
				</tfoot>
			</table>
		</div>
	);
};

PaymentSummary.propTypes = {
	totalPrice: PropTypes.number.isRequired,
	quantityOfTickets: PropTypes.number.isRequired,
	ticketPrice: PropTypes.number.isRequired,
};

export default PaymentSummary;
